









































































































import Vue from "vue";
import Checkbox from "../../components/Checkbox.vue";
import ButtonAction from "../../components/ButtonAction.vue";
import { Autorisatie } from "../../Autorisatie";
import { EventBus } from "../../lib/EventBus";
import axios from "axios";
import orderBy from "lodash-es/orderBy";
import get from "lodash-es/get";

export interface CheckboxItemModel {
  Id: number;
  Omschrijving: string;
  Checked: boolean;
}

export interface CheckboxItemStringModel {
  Id: string;
  Omschrijving: string;
  Checked: boolean;
}

export interface UserDetailViewModel {
  Id: string;
  Naam: string;
  Email: string;
  Active: boolean;
  NewPassword: string;
  HasNewPassword: boolean;
  Autorisaties: CheckboxItemModel[];
  Zones: CheckboxItemModel[];
  Groepen: CheckboxItemStringModel[];
}

export default Vue.extend({
  components: {
    Checkbox,
    ButtonAction
  },
  data() {
    return {
      loading: false,
      attempt: 0,
      selected_groep: "",
      selected_mode: "Z",
      user: {
        Id: "",
        Naam: "",
        Email: "",
        Active: false,
        HasNewPassword: false,
        NewPassword: "",
        Autorisaties: [],
        Zones: [],
        Groepen: []
      } as UserDetailViewModel
    };
  },
  mounted() {
    this.loading = true;
    this.getUser();
  },
  computed: {
    modeOptions(): any[] {
      return [
        {text: this.regionAlias, value: "Z"},
        {text: this.groupSingle, value: "G"}
      ] 
    },
    groupsEnabled() : boolean {
      return this.$store.getters.groupsEnabled();
    },
    groupSingle(): string {
      return this.$store.getters.groupSingle(this.$i18n.locale);
    },
    groupMultiple(): string {
      return this.$store.getters.groupMultiple(this.$i18n.locale);
    },
    regionAlias(): string {
      let alias = this.$store.getters.regionAlias()
      if (alias == null)
        return `${this.$t("region")}`;
      return alias;
    },
    nameState(): null | boolean {
      if (this.attempt > 0) {
        return !!this.user.Naam ? null : false;
      }
      return null;
    },
    emailState(): null | boolean {
      if (this.attempt > 0) {
        return !!this.user.Naam ? null : false;
      }
      return null;
    },
    passwordState(): null | boolean {
      if (this.attempt > 0) {
        return !!this.user.NewPassword
          ? this.user.NewPassword.length >= 8
            ? null
            : false
          : false;
      }
      return null;
    },

    zonesSorted(): CheckboxItemModel[] {
      return orderBy(get(this.user, "Zones", []), ["Omschrijving"], ["asc"]);
    },
    groepenSorted(): CheckboxItemStringModel[] {
      return orderBy(get(this.user, "Groepen", []), ["Omschrijving"], ["asc"]);
    },
    authorisationsSorted(): CheckboxItemModel[] {
      let all = get(this.user, "Autorisaties", []).filter(
        el => el.Id !== Autorisatie.GebruikerInloggen
      );
      all.forEach(element => {
        switch (element.Id) {
          case Autorisatie.GebruikerInloggen:
            element.Omschrijving = `${this.$i18n.t("login")}`;
            break;
          case Autorisatie.SysteemImporteur:
            element.Omschrijving = `${this.$i18n.t("administrator")}`;
            break;
          case Autorisatie.LeadDashboard:
            element.Omschrijving = `${this.$i18n.t("leads")}`;
            break;
          case Autorisatie.BeheerUsers:
            element.Omschrijving = `${this.$i18n.t("beheertitel")}`;
            break;
          case Autorisatie.DashboardOrders:
            element.Omschrijving = `${this.$i18n.t("orders")}`;
            break;
          case Autorisatie.RapportageLeads:
            element.Omschrijving = `${this.$i18n.t("rapportageleads")}`;
            break;
          case Autorisatie.RapportageOrders:
            element.Omschrijving = `${this.$i18n.t("rapportageorders")}`;
            break;
          case Autorisatie.RapportageDealerleads:
            element.Omschrijving = `${this.$i18n.t("rapportagedealerleads")}`;
            break;                            
          default:
            break;
        }
      });
      return orderBy(all, ["Omschrijving"], ["asc"]);
    }
  },
  methods: {
    getUser() {
      const id = this.$route.params.id;
      axios
        .get("/api/backend/v1/users/" + id)
        .then(response => {
          if (!!response && !!response.data) {
            if (response.data.Result && !!response.data.User) {
              this.user = response.data.User;

              // Zet mode en actieve groep
              let groep = this.user.Groepen.find(a => a.Checked == true)
              if (groep != undefined) {
                this.selected_groep = groep.Id
                this.selected_mode = "G"
              }
              

            } else {
              EventBus.$emit("add-toastr", {
                text: `${this.$i18n.t("generalerror")}`,
                type: "error"
              });
            }

            this.loading = false;
          }
        })
        .catch(error => {});
    },
    onCancelButtonClicked() {
      this.$router.push({ name: "users" });
    },
    onSaveButtonClicked() {
      this.attempt++;

      if (!this.user.Naam || !this.user.Email) return;

      //inloggen is hidden, altijd aanzetten
      let gebruikerInloggen = get(this.user, "Autorisaties", []).filter(
        el => el.Id === Autorisatie.GebruikerInloggen
      );
      if (gebruikerInloggen.length > 0) gebruikerInloggen[0].Checked = true;
      
      switch (this.selected_mode){
        // Omdat groepen en zones exlusief zijn moeten de andere info geleegd worden voor verzending
        case "G":
          //usergroepen vervangen met geselecteerde
          this.user.Groepen.forEach(g => g.Checked = g.Id == this.selected_groep)
          this.user.Zones.forEach(z => z.Checked = false)
          break;
        case "Z":
          this.user.Groepen.forEach(g => g.Checked = false)
          break;
      }
      
      const action =
        this.user.Id === "00000000-0000-0000-0000-000000000000"
          ? this.newUser
          : this.updateUser;

      action()
        .then(() => {
          this.$router.push({ name: "users" });
        })
        .catch(error => {
          if (
            !!error.response &&
            !!error.response.data &&
            !!error.response.data.Message
          ) {
            let msg = `${this.$i18n.t("generalerror")}`;
            const errorcode = error.response.data.Message;
            switch (errorcode) {
              case "1000":
                msg = `${this.$i18n.t("invalidinput")}`;
                break;
              case "1001":
                msg = `${this.$i18n.t("uniqueInput")}`;
                break;
              case "1002":
                msg = `${this.$i18n.t("passwordTooShort")}`;
                break;
              case "1003":
                msg = `${this.$i18n.t("passwordTooWeak")}`;
                break;
              case "1004":
                msg = `${this.$i18n.t("emailInvalid")}`;
                break;
              default:
                break;
            }

            if (!!msg) {
              EventBus.$emit("add-toastr", {
                text: msg,
                type: "error"
              });
            }
          }
        });
    },
    updateUser() {
      return axios.put("/api/backend/v1/users/" + this.user.Id, this.user, {
        headers: { "Content-Type": "application/json" }
      });
    },
    newUser() {
      this.user.Id = "00000000-0000-0000-0000-000000000000";
      return axios.post("/api/backend/v1/users", this.user, {
        headers: { "Content-Type": "application/json" }
      });
    },
    newPassword() {
      this.user.HasNewPassword = true;
    }
  }
});
